angular
	.module('AutoPrequal')
	.controller('tradeinDetailsCtrl', tradeinDetailsCtrl);

tradeinDetailsCtrl.$inject = ['$scope', '$rootScope', 'ScrollFactory', 'DataFactory', 'VehicleFactory'];

function tradeinDetailsCtrl($scope, $rootScope, ScrollFactory, DataFactory, VehicleFactory) {

	$rootScope.progressCurrent = 12;
	$rootScope.progressMobCurrent = 12;

	$scope.content = DataFactory.appData.content;
	$scope.localContent = DataFactory.appData.content.tradeinDetails;

	$scope.data = DataFactory.appData.applicant;
	$scope.updateDropdown = updateDropdown;
	$scope.showDropdown = showDropdown;
	$scope.updateVehicle = updateVehicle;
	$scope.checkHideDropdown = checkHideDropdown;
	$scope.displayList = false;
	$scope.vehicle = {};
	$scope.vehicleList = [];

	function updateDropdown() { debounceDropdown(); } 
	
	var debounceDropdown = _.debounce(function () {
		var value = $scope.Details.apTradeinDetails.$viewValue;
		var field = $scope.Details.apTradeinDetails;
		var details = value.split(" ");
		//check that at least a year and make are available
		if (details.length > 1) {
			var yearRegex = new RegExp(/^\d{4}$/g);
			if (yearRegex.test(details[0])) {
				var data = {};
				data.VehicleYear = details[0];
				data.Make = details[1];
				if (details.length > 2) data.Model = details[2];
				if (details.length > 3) data.Trim = details[3];
				if (details.length > 4) data.BodyStyle = details.slice(4).join(" ");
				VehicleFactory.autoComplete(data).then(function (response) {
					if (response.result_code === "0" && response.result_content.length) {
						field.$setValidity('', true);
						$scope.displayList = true;
						$scope.vehicleList = response.result_content;
					}
					else {
						field.$setValidity('', false);
						$scope.displayList = false;
					}
				});
			}
			else {
				field.$setValidity('', false);
				$scope.displayList = false;
			}
		}
		else {
			$scope.displayList = false;
			field.$setValidity('', true);
		}
	}, 500, { 'leading': false, 'trailing': true });

	function showDropdown() {
		if (document.activeElement.id === "apTradeinDetails" && $scope.Details.apTradeinDetails.$valid && $scope.vehicleList.length)
		{
			$scope.displayList = true;
		}
		else $scope.displayList = false;
	}

	function updateVehicle(vehicle) {
		$scope.data.apTradeinDetails = vehicle.description;
		$scope.data.uvc = vehicle.uvc;
		$scope.vehicle = vehicle;
		$scope.displayList = false;
		$scope.Details.apTradeinDetails.$setValidity('', true);
		ScrollFactory.lastVisibleStep("tradeinDetails");
	}

	function checkHideDropdown(num) {
		if (num == $scope.vehicleList.length - 1) $scope.displayList = false;
	}

	$rootScope.tradeinDetailsNextStep = function () {
		if ($scope.Details.$valid) {
			var data = {};
			data.KM = $scope.data.apTradeinKms;
			data.uvc = $scope.data.uvc;
			data.province = $scope.data.apProvince;
			VehicleFactory.getVehicle(data).then(function (response) {
				if (response.result_code === "0") {
					$scope.data.tradein_avg = response.result_content.tradein_avg;
					$scope.data.tradein_clean = response.result_content.tradein_clean;
					$scope.data.tradein_rough = response.result_content.tradein_rough;
					DataFactory.setData($scope.data);
					DataFactory.appData.applicant.appState.tradeinDetails = true;
					ScrollFactory.showStep("tradeinEstimate");
					ScrollFactory.goToStep("tradeinEstimate");
					return true;
				}
			});
		}
		else {
			angular.forEach($scope.Details.$error, function (field) {
				angular.forEach(field, function (errorField, index) {
					errorField.$setTouched();
					$rootScope.errorNumber = index + 1;
				})
			});
		}
	}

	$scope.prevStep = function () {
		ScrollFactory.showStep("tradeinHelp");
		ScrollFactory.goToStep("tradeinHelp");
	}
}
